import React, { useState } from 'react';
import { api } from '../api';
import toast from 'react-hot-toast';

// Generates a client-side idempotency key so a retried/duplicate submit
// (e.g. a flaky connection, a double-tap) never creates two completions —
// the server dedupes on this id.
function generateClientId() {
  if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export default function CompleteClass({ classItem, onDone, onCancel }) {
  const [notes, setNotes] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await api.completeClass({
        class_id: classItem.class_id,
        notes: notes.trim(),
        client_completion_id: generateClientId(),
      });
      toast.success('Class marked done! ✅');
      onDone && onDone();
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="complete-class-overlay" onClick={onCancel}>
      <div className="complete-class-card" onClick={e => e.stopPropagation()}>
        <h3>{classItem.name}</h3>
        {classItem.instructions && (
          <p className="class-instructions">{classItem.instructions}</p>
        )}
        <form onSubmit={handleSubmit}>
          <label>
            What did you do today?
            <textarea
              value={notes}
              onChange={e => setNotes(e.target.value)}
              placeholder="A couple sentences about what you did today…"
              rows={4}
              required
              autoFocus
            />
          </label>
          <div className="complete-class-actions">
            <button type="button" className="btn-secondary" onClick={onCancel}>Cancel</button>
            <button type="submit" className="btn-primary" disabled={loading || !notes.trim()}>
              {loading ? 'Saving…' : 'Complete'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
